import { render } from "./DemoModal.vue?vue&type=template&id=7d7e0d90"
import script from "./DemoModal.vue?vue&type=script&lang=js"
export * from "./DemoModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__